import { useEffect } from 'react';

export function useDictationRecordingSignal(isRecording: boolean, setRecording: (active: boolean) => void) {
  useEffect(() => {
    setRecording(isRecording);
  }, [isRecording, setRecording]);

  useEffect(() => {
    return () => {
      setRecording(false);
    };
  }, [setRecording]);
}
